import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';



// Review
export function getViewManageReviews(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-reviews`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathReviews(reviewId=null) {
  if (reviewId) {
      return `reviews/${reviewId}`;
  } else {
      return `reviews`;
  }
}

export function patchReviews(successCallback, errorCallback, data, reviewId) {
  patchAuth({
    "path": pathReviews(reviewId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReviews(successCallback, errorCallback, reviewId) {
  deleteAuth({
    "path": pathReviews(reviewId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathReplyReviews(reviewId) {
  return `reviews/${reviewId}/reply`;
}

export function postReplyReviews(successCallback, errorCallback, data, reviewId) {
  postAuth({
    "path": pathReplyReviews(reviewId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReplyReviews(successCallback, errorCallback, reviewId) {
  deleteAuth({
    "path": pathReplyReviews(reviewId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Review Collectors
function pathViewReviewsCollectorEditor(collectorId=null) {
  if (collectorId) {
      return `view/reviews-collector-editor/${collectorId}`;
  } else {
      return `view/reviews-collector-editor`;
  }
}

export function getViewReviewsCollectorEditor(successCallback, errorCallback, collectorId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReviewsCollectorEditor(collectorId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageReviewsCollectors(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-reviews-collectors`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathReviewsCollectors(collectorId=null) {
  if (collectorId) {
      return `reviews-collectors/${collectorId}`;
  } else {
      return `reviews-collectors`;
  }
}

export function createReviewsCollectors(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReviewsCollectors(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReviewsCollectors(successCallback, errorCallback, data, collectorId) {
  patchAuth({
    "path": pathReviewsCollectors(collectorId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReviewsCollectors(successCallback, errorCallback, collectorId) {
  deleteAuth({
    "path": pathReviewsCollectors(collectorId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export const URL_REVIEWS_COLLECTOR_LOGO_PIC_MEDIA = `/${constants.API_VERSION}/reviews-collectors/logo-pic-media`;


// Review Widgets
function pathViewReviewsWidgetEditor(widgetId=null) {
  if (widgetId) {
      return `view/reviews-widget-editor/${widgetId}`;
  } else {
      return `view/reviews-widget-editor`;
  }
}

export function getViewReviewsWidgetEditor(successCallback, errorCallback, widgetId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReviewsWidgetEditor(widgetId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageReviewsWidgets(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-reviews-widgets`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathReviewsWidgets(widgetId=null) {
  if (widgetId) {
      return `reviews-widgets/${widgetId}`;
  } else {
      return `reviews-widgets`;
  }
}

export function createReviewsWidgets(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReviewsWidgets(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReviewsWidgets(successCallback, errorCallback, data, widgetId) {
  patchAuth({
    "path": pathReviewsWidgets(widgetId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReviewsWidgets(successCallback, errorCallback, widgetId) {
  deleteAuth({
    "path": pathReviewsWidgets(widgetId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Star Rating
function pathViewStarRatingEditor(starRatingId=null) {
  if (starRatingId) {
      return `view/star-rating-editor/${starRatingId}`;
  } else {
      return `view/star-rating-editor`;
  }
}

export function getViewStarRatingEditor(successCallback, errorCallback, starRatingId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewStarRatingEditor(starRatingId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageStarRatings(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-star-ratings`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathStarRatings(starRatingId=null) {
  if (starRatingId) {
      return `star-ratings/${starRatingId}`;
  } else {
      return `star-ratings`;
  }
}

export function createStarRatings(successCallback, errorCallback, data) {
  postAuth({
    "path": pathStarRatings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchStarRatings(successCallback, errorCallback, data, starRatingId) {
  patchAuth({
    "path": pathStarRatings(starRatingId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteStarRatings(successCallback, errorCallback, starRatingId) {
  deleteAuth({
    "path": pathStarRatings(starRatingId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// BigCommerce Reviews
export function getViewManageBigCommerceReviews(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-bigcommerce-reviews`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

